export default "__VITE_ASSET__DexL$dub__"